import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusDot',
  props: {
    status: {}
  },
  setup(__props: any) {



const borderMap: Record<string, string> = {
  vinculada: 'border border-green-500',
  em_edicao: 'border border-yellow-400',
  nao_vinculada: 'border border-red-500'
}

const bgMap: Record<string, string> = {
  vinculada: 'bg-green-100',
  em_edicao: 'bg-yellow-100',
  nao_vinculada: 'bg-red-100'
}

const labelMap: Record<string, string> = {
  vinculada: 'Vinculada',
  em_edicao: 'Em edição',
  nao_vinculada: 'Não vinculada'
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { location: "top" }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("span", _mergeProps(props, {
        class: ['inline-block w-2 h-5 rounded-full mr-2', borderMap[_ctx.status], bgMap[_ctx.status]]
      }), null, 16)
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(labelMap[_ctx.status]), 1)
    ]),
    _: 1
  }))
}
}

})